import "../styles/HomeNew.css";
//<!--href="https://chat.whatsapp.com/Bn8JUtw7Yhy3Xq4yoGIQCH"-->

const PHOTOS = [
  {
    src: "/images/YVC/Parklands-July.png",
    caption: "Partnering with the Parkland Foundation for invasive plant removal and trail maintenance.",
    org: "Parklands Foundation",
    month: "July",
    color: "lchip--green",
  },
  {
    src: "/images/YVC/MCMH-March.png",
    caption: "Helping McLean County Museum of History clean up Museum Square after the Easter Egg Hunt.",
    org: "McLean County Museum",
    month: "March",
    color: "lchip--purple",
  },
  {
    src: "/images/YVC/Midwest-January.png",
    caption: "Teamed up with Midwest Food Bank to pack 60 boxes, each filled with 20 lasagna pasta family bags.",
    org: "Midwest Food Bank",
    month: "January",
    color: "lchip--pink",
  },
  {
    src: "/images/YVC/MCMH-November.png",
    caption: "Packed cards and wrote letters for residents in assisted living facilities.",
    org: "McLean County Museum",
    month: "November",
    color: "lchip--purple",
  },
  {
    src: "/images/YVC/EAC-September.png",
    caption: "Partnered with the Ecology Action Center to help with storm drain stenciling and raise awareness about water pollution.",
    org: "Ecology Action Center",
    month: "September",
    color: "lchip--green",
  },
  {
    src: "/images/YVC/Zoo-march.png",
    caption: "Assisted Miller Park Zoo with the Stampede event.",
    org: "Miller Park Zoo",
    month: "March",
    color: "lchip--pink",
  },
];

const PARTNERS = [
  "Midwest Food Bank",
  "Miller Park Zoological Society",
  "McLean County History Museum",
  "Ecology Action Center",
  "Parklands Foundation",
  "FBT Telethon",
  "Kite Fest 2024",
  "Grant Review Committee",
];

export default function YVC() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "48svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Youth Volunteer<br />
              <span className="hero__accent">Corps</span>
            </h1>
            <p className="hero__sub">
              Empowering youth and adults to create meaningful change through
              volunteerism. Monthly events that support nonprofits and build
              the next generation of servant leaders.
            </p>
            <div className="hero__pills">
              <span className="pill pill--purple">Ages 10+</span>
              <span className="pill pill--pink">Monthly Events</span>
              <span className="pill pill--green">Community Impact</span>
            </div>
            <div className="hero__ctas">

              <a

                href="https://www.forbettertomorrow.org/contact"
                target="_blank"
                rel="noopener noreferrer"
                className="cta cta--solid"
              >
                Contact us to Join →
              </a>
              <a href="#gallery" className="cta cta--ghost">See Our Work ↓</a>
            </div>
          </div>
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">12+</span>
              <span className="hstat__l">Events / Year</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">8+</span>
              <span className="hstat__l">Partner Orgs</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">10+</span>
              <span className="hstat__l">Min. Age</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">About YVC</span>
          <h2 className="sec-h2">What We Do</h2>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: ".85rem" }}>
          {[
            "At For A Better Tomorrow, we empower youth and adults to create meaningful change through volunteerism. Our Youth Volunteer Corps (YVC) organizes monthly events that support various nonprofits and community initiatives.",
            "By volunteering with YVC, you'll have the opportunity to lead and participate in impactful activities that strengthen our community while building connections and fostering personal growth.",
            "In 2024, YVC partnered with organizations like Midwest Food Bank, Miller Park Zoological Society, McLean County History Museum, Ecology Action Center, Parklands Foundation, and more. Volunteers also supported For A Better Tomorrow's initiatives, including the FBT Telethon, Kite Fest 2024, and Grant Review Committee.",
          ].map((text, i) => (
            <div key={i} className="lcard" style={{ flexDirection: "row", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{
                flexShrink: 0, width: 10, height: 10, borderRadius: "50%", marginTop: ".55rem",
                background: i === 0 ? "var(--pu-500)" : i === 1 ? "var(--pk-500)" : "var(--gn-500)",
                boxShadow: `0 0 6px ${i === 0 ? "var(--pu-200)" : i === 1 ? "var(--pk-200)" : "var(--gn-200)"}`,
              }} />
              <p style={{ fontSize: ".93rem", color: "var(--muted)", lineHeight: 1.8 }}>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── REQUIREMENTS & CONTACT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingTop: 0 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.25rem" }}>

          {/* Requirements */}
          <div className="lcard lcard--open" style={{ background: "var(--pu-50)", borderColor: "var(--pu-200)", gap: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
              <span style={{ fontSize: "1.5rem" }}>📋</span>
              <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1rem", fontWeight: 800, color: "var(--ink)" }}>
                Volunteer Requirements
              </h3>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: ".6rem", borderTop: "1px solid var(--pu-200)", paddingTop: ".75rem" }}>
              {[
                "Unless specified, volunteers must be at least 10 years old.",
                "Younger volunteers must be accompanied by an adult, preferably a parent or guardian.",
              ].map((req, i) => (
                <div key={i} style={{ display: "flex", gap: ".6rem", alignItems: "flex-start" }}>
                  <span style={{ color: "var(--pu-500)", fontWeight: 800, flexShrink: 0 }}>✓</span>
                  <p style={{ fontSize: ".85rem", color: "var(--muted)", lineHeight: 1.7 }}>{req}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Stay Updated */}
          <div className="lcard lcard--open" style={{ background: "var(--gn-50)", borderColor: "var(--gn-200)", gap: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
              <span style={{ fontSize: "1.5rem" }}>📣</span>
              <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1rem", fontWeight: 800, color: "var(--ink)" }}>
                Stay Updated
              </h3>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: ".75rem", borderTop: "1px solid var(--gn-200)", paddingTop: ".75rem" }}>
              <p style={{ fontSize: ".85rem", color: "var(--muted)", lineHeight: 1.7 }}>
                Join FBT's{" "}
                <a href="https://www.forbettertomorrow.org/contact" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gn-500)", fontWeight: 700 }}>
                  WhatsApp group ↗
                </a>{" "}
                to stay informed about future monthly volunteer opportunities.
              </p>
              <p style={{ fontSize: ".85rem", color: "var(--muted)", lineHeight: 1.7 }}>
                Questions or project ideas? Email{" "}
                <a href="mailto:contactus@forbettertomorrow.org" style={{ color: "var(--gn-500)", fontWeight: 700 }}>
                  contactus@forbettertomorrow.org
                </a>
              </p>
              <a
                href="https://www.forbettertomorrow.org/contact"
                target="_blank"
                rel="noopener noreferrer"
                className="lcard__toggle"
                style={{ borderColor: "var(--gn-200)", color: "var(--gn-500)", alignSelf: "flex-start" }}
              >
                Contact us to Join →
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* ── 2024 PARTNERS ── */}
      <section className="local" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "860px", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">2024 Partners</span>
            <h2 className="sec-h2">Organizations We Served</h2>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: ".6rem", justifyContent: "center" }}>
            {PARTNERS.map((p, i) => (
              <span key={p} className={`lcard__chip ${i % 3 === 0 ? "lchip--purple" : i % 3 === 1 ? "lchip--pink" : "lchip--green"}`}
                style={{ fontSize: ".82rem", padding: ".45em 1.1em" }}>
                {p}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ── PHOTO GALLERY ── */}
      <section id="gallery" className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">In Action</span>
          <h2 className="sec-h2">YVC Gallery</h2>
          <p className="sec-sub">A look at some of our recent volunteer events across the community.</p>
        </div>
        <div className="local__grid">
          {PHOTOS.map((photo, i) => (
            <div key={i} className="lcard" style={{ padding: 0, gap: 0, overflow: "hidden" }}>
              <div style={{ width: "100%", aspectRatio: "3/2", overflow: "hidden" }}>
                <img
                  src={photo.src}
                  alt={photo.caption}
                  loading="lazy"
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", transition: "transform .35s" }}
                  onMouseEnter={e => (e.target.style.transform = "scale(1.05)")}
                  onMouseLeave={e => (e.target.style.transform = "scale(1)")}
                />
              </div>
              <div style={{ padding: "1rem 1.1rem 1.1rem" }}>
                <div style={{ display: "flex", gap: ".4rem", marginBottom: ".5rem" }}>
                  <span className={`lcard__chip ${photo.color}`} style={{ fontSize: ".6rem" }}>{photo.org}</span>
                  <span className="lcard__chip lchip--purple" style={{ fontSize: ".6rem", background: "var(--pu-50)", color: "var(--pu-500)" }}>{photo.month}</span>
                </div>
                <p style={{ fontSize: ".83rem", color: "var(--muted)", lineHeight: 1.65 }}>{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>"Be part of a dedicated team committed to giving back and creating a better tomorrow!"</p>
      </div>

    </div>
  );
}